// extracted by mini-css-extract-plugin
export default {"collage":"Espufi_collage__4bwYU","datos":"Espufi_datos__rEcuF"};